import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/LoginRegister/Login.vue'
import Register from '@/pages/LoginRegister/Register.vue'
import EmailActivation from '@/pages/LoginRegister/Emailactivation.vue'
import Passwordreset from '@/pages/LoginRegister/Passwordreset.vue'
import Newpassword from '@/pages/Settings/Newpassword.vue'
import Newemail from '@/pages/Settings/Newemail.vue'
import Managername from '@/pages/Settings/Managername.vue'
import Teamname from '@/pages/Settings/Teamname.vue'
import Teamlogo from '@/pages/Settings/Teamlogo.vue'
import Managerbild from '@/pages/Settings/Managerbild.vue'
import Settings from '@/pages/Settings/Settings.vue'
import Home from '@/pages/Home.vue'
import Impressum from '@/pages/Impressum.vue'
import Datenschutz from '@/pages/Datenschutz.vue'
import AGB from '@/pages/Agb.vue'
import NotFound404 from '@/pages/NotFound404.vue'
import Help from '@/pages/Help.vue'
import Changelog from '@/pages/Changelog.vue'
import Office from '@/pages/Office.vue'
import Fahrzeug from '@/pages/Fahrzeug.vue'
import Kegelbahn from '@/pages/Kegelbahn.vue'
import Finanzen from '@/pages/Finanzen.vue'
import Mannschaft from '@/pages/Mannschaft.vue'
import Training from '@/pages/Training.vue'
import Aufstellung from '@/pages/Aufstellung.vue'
import Vertrag from '@/pages/Vertrag.vue'
import Saison from '@/pages/Saison.vue'
import Spenden from '@/pages/Spenden.vue'
import EMailverification from '@/pages/Settings/EMailverification.vue'
import Deleteaccount from '@/pages/Settings/Deleteaccount.vue'

import Meta from 'vue-meta'
Vue.use(Meta)

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/spenden',
      name: 'Spenden',
      component: Spenden,
      meta: { requiresAuth: true }
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/new-email/:email/:code',
      name: 'EMailverification',
      component: EMailverification
    },
    {
      path: '/saison',
      name: 'Saison',
      component: Saison,
      meta: { requiresAuth: true }
    },
    {
      path: '/vertrag',
      name: 'Vertrag',
      component: Vertrag,
      meta: { requiresAuth: true }
    },
    {
      path: '/aufstellung',
      name: 'Aufstellung',
      component: Aufstellung,
      meta: { requiresAuth: true }
    },
    {
      path: '/training',
      name: 'Training',
      component: Training,
      meta: { requiresAuth: true }
    },
    {
      path: '/mannschaft',
      name: 'Mannschaft',
      component: Mannschaft,
      meta: { requiresAuth: true }
    },
    {
      path: '/finanzen',
      name: 'Finanzen',
      component: Finanzen,
      meta: { requiresAuth: true }
    },
    {
      path: '/bahn',
      name: 'Kegelbahn',
      component: Kegelbahn,
      meta: { requiresAuth: true }
    },
    {
      path: '/fahrzeug',
      name: 'Fahrzeug',
      component: Fahrzeug,
      meta: { requiresAuth: true }
    },
    {
      path: '/buero',
      name: 'Buero',
      component: Office,
      meta: { requiresAuth: true }
    },
    {
      path: '/email/activate',
      name: 'Emailactivation',
      component: EmailActivation
    },
    {
      path: '/reset-password',
      name: 'Passwordreset',
      component: Passwordreset
    },
    {
      path: '/settings/teamlogo',
      name: 'Teamlogo',
      component: Teamlogo,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings/teamname',
      name: 'Teamname',
      component: Teamname,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings/managername',
      name: 'Managername',
      component: Managername,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings/managerbild',
      name: 'Managerbild',
      component: Managerbild,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings/new-password',
      name: 'Newpassword',
      component: Newpassword,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings/new-email',
      name: 'Newemail',
      component: Newemail,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings/deleteAccount',
      name: 'Deleteaccount',
      component: Deleteaccount,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/changelog',
      name: 'Changelog',
      component: Changelog
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum
    },
    {
      path: '/agb',
      name: 'AGB',
      component: AGB
    },
    {
      path: '/datenschutz',
      name: 'Datenschutz',
      component: Datenschutz
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '*',
      name: '404',
      component: NotFound404
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // this.$store.commit('clearError')
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
